import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

import { useSession } from '@/contexts/auth/session'
import { getFeatureFlags } from '@/services/fintalk/services/fintalk-backoffice/feature-flags/get-feature-flags'
import { useFeatureFlags } from '@/stores/use-feature-flags'

export function FeatureFlagsProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const {
    state: { isUserAuthenticated },
  } = useSession()

  useEffect(() => {
    if (!isUserAuthenticated) {
      useFeatureFlags.getState().resetFeatureFlags()
      return
    }

    let cancelled = false

    const fetchFlags = async () => {
      try {
        const { flags } = await getFeatureFlags()

        if (cancelled) {
          return
        }

        useFeatureFlags.getState().setFeatureFlags(flags ?? {})
      } catch (error) {
        Sentry.captureException(error)

        if (!cancelled) {
          // Ensure guards/consumers don't wait forever when the API fails;
          // fall back to the default flag values.
          useFeatureFlags.getState().markAsLoaded()
        }
      }
    }

    fetchFlags()

    return () => {
      cancelled = true
    }
  }, [isUserAuthenticated])

  return <>{children}</>
}
